import CreateHttpClient from './createTimetablesWebApiHttpClient';
import { AxiosInstance } from 'axios';
import Message from '../models/special-message/message';
import moment from 'moment';
import { MOMENT_DATE_FORMAT } from '../constants/date_format';

class MessagesApi {
    private httpClient: AxiosInstance;

    constructor() {
        this.httpClient = CreateHttpClient();
    }

    async GetAll(campusId?: number, schoolId?: number) {
        let url = '/messages';

        if (schoolId) url += `?schoolId=${schoolId}`;
        if (campusId && schoolId) url += `&campusId=${campusId}`;
        else if (campusId) url += `?campusId=${campusId}`;

        const { data } = await this.httpClient.get(url);
        return data;
    }

    async SaveMessage(message: Message) {
        const payload = {
            ...message,
            date: moment(message.date).format(MOMENT_DATE_FORMAT),
        };

        const { data } = await this.httpClient.put('/messages', payload);
        return data;
    }

    async GetMessageByDate(date: Date) {
        const formaattedDate = moment(date).format(MOMENT_DATE_FORMAT);
        const { data, status } = await this.httpClient.get(`/messages/${formaattedDate}`);

        if (status === 204) return null;

        return data;
    }

    async DeleteMessage(id: number) {
        await this.httpClient.delete(`/messages/${id}`);
    }
}

export default MessagesApi;
